import { data } from "jquery";
import { postRequest } from "../config/AxiosConfig"
import API_URLS from "../config/BackendConfig"
import { getAuthToken } from "../utils/tokenUtils";

export const RetriveApiKeyReportService = async ({ totalData, userId, currentPage }) => {
    try {
        const payload = {
            'total_data': userId !==""?1:parseInt(totalData),
            'user_id': userId,
            'page':userId !==""?1 : currentPage
        }
        const token = getAuthToken();
        const respone = await postRequest({
            url: API_URLS.ADMIN + 'api-key/report',
            headers: {
                'Authorization': `Bearer ${token}`
            },
            data: payload,
        });
        return respone
    } catch (error) {
        return error;
    }
}
export const RetriveApiKeyReportServiceByFilter = async ({ totalData, fromData, toDate, userId, serviceStatus }) => {
    try {
        const payload = {
            'total_data': totalData,
            'from_date': fromData,
            'to_date': toDate,
            'user_id': userId,
            'status': serviceStatus
        }
        const token = getAuthToken();
        const respone = await postRequest({
            url: API_URLS.ADMIN + 'api-key/report',
            data: payload,
            headers: { 'Authorization': `Bearer ${token}` },

        });
        return respone
    } catch (error) {
        return error;
    }
}

export const toggleStatusService = ({ apiKeyId }) => {
    try {
        const payload = {
            "api_key_id": apiKeyId
        }
        const token = getAuthToken();
        const response = postRequest({
            url: API_URLS.ADMIN + "api-key/toggle-status",
            data: payload,
            headers: { 'Authorization': `Bearer ${token}` }
        })
        return response
    } catch (error) {
        return error
    }
}
export const toggleEnvService = ({ apiKeyId }) => {
    try {
        const payload = {
            "api_key_id": apiKeyId
        }
        const token = getAuthToken();
        const response = postRequest({
            url: API_URLS.ADMIN + "api-key/toggle-environment",
            data: payload,
            headers: { 'Authorization': `Bearer ${token}` }
        })
        return response
    } catch (error) {
        return error
    }
}
export const fetchUserKeys = (payload) => {
    try {
        
        const token = getAuthToken();
        const response = postRequest({
            url: API_URLS.ADMIN + "api-key/fetch",
            data: payload,
            headers: { 'Authorization': `Bearer ${token}` }
        })
        return response
    } catch (error) {
        return error
    }
}
export const changeUserKeys = (payload) => {
    try {
      
        const token = getAuthToken();
        const response = postRequest({
            url: API_URLS.ADMIN + "api-key/change",
            data: payload,
            headers: { 'Authorization': `Bearer ${token}` }
        })
        return response
    } catch (error) {
        return error
    }
}